import React from 'react';
import { Tabs, TabsProps } from '@mui/material';

interface TabsHeaderProps extends TabsProps {
  value: number | false;
  onChange: (event: React.SyntheticEvent, newValue: number) => void;
  children?: React.ReactNode;
}

const TabsHeader: React.FC<TabsHeaderProps> = ({
  value,
  onChange,
  children,
  ...rest
}) => {
  return (
    <Tabs value={value} onChange={onChange} {...rest}>
      {children}
    </Tabs>
  );
};

export default TabsHeader;
